import { AxiosError } from "axios";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";

export type UtterancesResponse = {
  confidence: number;
  end: number;
  speaker: string;
  start: number;
  text: string;
  words: {
    text: string;
    start: number;
    end: number;
    confidence: number;
    speaker: string;
  }[];
}[];

export const useUtterancesJson = (url?: string) => {
  return useQuery<any, AxiosError<any>, UtterancesResponse>(
    ["utterancesJson", url],
    () =>
      axiosClient.get<UtterancesResponse>(url || "").then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!url,
    }
  );
};
